module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraLightItalic.3dcdf5b.woff2";